export const analyticsEventType = {
  GAME_OVER: 'GAME_OVER',
  GAME_START: 'GAME_START',
  GAME_RESTART: 'GAME_RESTART',
  GAME_VIEW: 'GAME_VIEW',
  CTA_CLICK: 'CTA_CLICK',
};
